// Import all path collections
import { planningPaths, purchasePaths, inventoryPaths, productionPaths } from './erpPaths';
import { ticketPaths } from './ticketPaths';
export { getPath } from './type';
// Combine all paths into one object
const urlPath = {
    ...planningPaths,
    ...purchasePaths,
    ...inventoryPaths,
    ...productionPaths,
    ...ticketPaths
};
export default urlPath;
// Also export individual path collections for specific use cases
export { planningPaths, purchasePaths, inventoryPaths, productionPaths, ticketPaths };
